import type { LabelHTMLAttributes, ReactNode } from 'react';
import { cn } from '../../lib/cn';

export interface LabelProps extends LabelHTMLAttributes<HTMLLabelElement> {
  readonly required?: boolean;
  /**
   * Yorliq yonidagi kichik izoh — «ixtiyoriy», «QQS siz», «UZS da».
   *
   * Nima uchun yorliqning O'ZIDA: bunday izoh ilgari yorliq matniga
   * qavs ichida qo'shib yozilardi («Summa (UZS siz)»). Natijada u
   * yorliqning bir qismi bo'lib, skrinrider maydon nomini uzun jumla
   * qilib o'qirdi va formalarni tez ko'rib chiqish qiyinlashardi.
   * Endi izoh ko'z bilan ajralib turadi va nom qisqa qoladi.
   */
  readonly hint?: ReactNode;
}

export function Label({ className, required, hint, children, ...props }: LabelProps): ReactNode {
  return (
    <label
      /*
       * `text-ink-muted` emas, `text-ink`: yorliq — formadagi asosiy
       * yo'l-yo'riq. Ilgari xiralashtirilgan yorliqlar ekranni «tinch»
       * qilardi, lekin shoshib to'ldirilayotgan formada foydalanuvchi
       * qaysi katakka nima yozishini adashtirardi.
       *
       * `flex` — yulduzcha va izoh matn bilan bir chiziqda tursin,
       * uzun yorliq esa o'ralganda ham tekislikni saqlasin.
       */
      className={cn('flex flex-wrap items-baseline gap-x-1.5 text-sm font-medium text-ink', className)}
      {...props}
    >
      <span>
        {children}
        {required && (
          // Yulduzcha `aria-hidden` — skrinrider uchun maydon `required` atributi orqali bildiriladi.
          <span aria-hidden className="ml-0.5 text-danger">
            *
          </span>
        )}
      </span>
      {hint !== undefined && hint !== null && hint !== false && (
        <span className="text-xs font-normal text-ink-muted">{hint}</span>
      )}
    </label>
  );
}
